import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { CardActionArea, CardContent, Typography, useMediaQuery, useTheme } from '@mui/material';

import InsuranceTypeIcon from '../../../icons/InsuranceTypeIcon';
import CaretRightIcon from '../../../icons/CaretRightIcon';
import { getNameAccordingToInsuranceCategory } from '../../../utils/customerUtils';
import { GET_CUSTOMER } from '../../../shared';

import {
  StyledCurrentlySelectedContractCardContent,
  StyledCurrentlySelectedContractCardTextContent,
  StyledCurrentlySelectedContractCard,
  StyledCurrentlySelectedContractPaper,
} from './CurrentlySelectedContractCard.styled';

function CurrentlySelectedContractCardContent({ name, policyName }) {
  return (
    <>
      <InsuranceTypeIcon />

      <StyledCurrentlySelectedContractCardTextContent>
        <Typography variant="h3">{name}</Typography>

        <Typography variant="p">{policyName}</Typography>
      </StyledCurrentlySelectedContractCardTextContent>
    </>
  );
}

export default function CurrentlySelectedContractCard() {
  const history = useHistory();

  const { data } = useQuery(GET_CUSTOMER);
  const customer = data?.customer;

  const name = getNameAccordingToInsuranceCategory(customer);
  const policyName = customer?.contract?.policyName || '';

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));

  if (isDesktop) {
    return (
      <StyledCurrentlySelectedContractPaper elevation={0}>
        <StyledCurrentlySelectedContractCardContent>
          <CurrentlySelectedContractCardContent name={name} policyName={policyName} />
        </StyledCurrentlySelectedContractCardContent>
      </StyledCurrentlySelectedContractPaper>
    );
  }

  return (
    <StyledCurrentlySelectedContractCard elevation={0}>
      <CardActionArea
        aria-label={`${name} ${policyName}`}
        onClick={() => history.push('/switch-customer-mobile')}
      >
        <CardContent>
          <StyledCurrentlySelectedContractCardContent>
            <CurrentlySelectedContractCardContent name={name} policyName={policyName} />

            <CaretRightIcon stroke={theme.palette.main.professional_blue} />
          </StyledCurrentlySelectedContractCardContent>
        </CardContent>
      </CardActionArea>
    </StyledCurrentlySelectedContractCard>
  );
}
